import React, { useEffect, useState } from "react";
import classes from "../../../assets/styles/PageComponentsStyles/Settings/Notification.module.css";
import { DELETE_USER_NFCS } from "../../../utils/constants/apiUrl";
import { post } from "../../../server";
import { loggedInUser } from "../../../utils/store";
import { useAtom } from "jotai";
import Loader from "../../Loader";
import showToast from "../../../helpers/showToast";
import ConfirmationModal from "../../Modals/ConfirmationModal";
import _ from "lodash";
const NFCs = ({ setKey }) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const [nfcs, setNfcs] = useState({
    remove_nfc: false,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e, i) => {
    const name = e.target.name;
    const value = e.currentTarget.checked;
    setNfcs({ ...nfcs, [name]: value });
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    let { status, message, data } = await post(
      `${DELETE_USER_NFCS}`,
      nfcs,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    showToast(status, message);
    if (status) {
      let logUserData = _.cloneDeep(loggedUser);
      logUserData.active_nfc = false;
      setLoggedUser(logUserData);
    }
    setNfcs({ ...nfcs, remove_nfc: false });
    setLoading(false);
  };

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = () => {
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message, data } = await post(
      `${DELETE_USER_NFCS}`,
      nfcs,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    showToast(status, message);

    if (status) {
      let logUserData = _.cloneDeep(loggedUser);
      logUserData.active_nfc = false;
      setLoggedUser(logUserData);
    }
    setKey("profile");
    setLoading(false);
  };

  useEffect(() => {
    setNfcs({ ...nfcs, remove_nfc: loggedUser.active_nfc });
  }, []);
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className={classes.notificationWrapper}>
        <div className={classes.inputWrapper}>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className={classes.switchWrapper}>
                <p className={classes.emailTitle}>Remove NFCs</p>
                {/* <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    name="remove_nfc"
                    disabled={!nfcs.remove_nfc ? true : false}
                    checked={nfcs.remove_nfc}
                    onChange={(e) => handleChange(e)}
                  />
                </div> */}
              </div>
              <p
                className={classes.info}
                style={{
                  borderBottom: "1px solid var(--border_color)",
                  paddingBottom: "15px",
                }}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit,
              </p>
            </div>
            <div className="col-md-4 col-12"></div>
            <div className="col-md-4 col-12"></div>
          </div>
        </div>
        <div className={classes.submitBtnWrapper} onClick={handleDelete}>
          <button type="button">Remove</button>
        </div>
      </div>

      <ConfirmationModal
        show={showConfirmationModal}
        handleCloseModal={handleCloseConfirmationModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="nfc"
      />

      <style type="text/css">
        {`
        .form-check-input:disabled {
          opacity: 1;
      }
	`}
      </style>
    </>
  );
};

export default NFCs;
